export enum NotificationDeliveryTypeEnum {
  Email = 'Email',
  SMS = 'SMS',
  Voice = 'Voice',
  Push = 'Push',
}

export enum ContentNotificationDeliveryTypeEnum {
  Email = 'Email',
  Push = 'Push',
  SMS = 'SMS',
}

export const CONTENT_NOTIFICATION_DELIVERY_TYPES: ContentNotificationDeliveryTypeEnum[] = [
  ContentNotificationDeliveryTypeEnum.Email,
  ContentNotificationDeliveryTypeEnum.Push,
  ContentNotificationDeliveryTypeEnum.SMS,
];
